import { loadScript } from '/src/utils';

const trustpilotLoadWidget = () => {
    setTimeout(() => {
        loadScript('//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js')
            .catch(() => console.log('load trustpilot error'));
    }, 5000)
};

const trustpilotCreateInvitation = ({ order_invitation_data }, key) => {
    if (window.tp) {
        window.tp('createInvitation', JSON.parse(order_invitation_data));
    } else {
        const n = 'tp';
        const w = window;
        w.TrustpilotObject=n;w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)};

        loadScript('https://invitejs.trustpilot.com/tp.min.js')
            .then(() => {
                window.tp('register', key);
                window.tp('createInvitation', JSON.parse(order_invitation_data));
            }).catch(errors => console.log(errors));
    }
};

export {
    trustpilotLoadWidget,
    trustpilotCreateInvitation,
};
